import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { DeliveryEngagementsService } from '../delivery-engagements.service';
import { DeliveryEngagementsCompletedEngagementsViewPart } from './completed-engagements/completed-engagements-view.part';
import { DeliveryContactReqFollowUpsViewPart } from './contact-request/contact-request-view.part';
import { DeliveryEngagementsOpenEngagementsViewPart } from './open-engagements/open-engagements-view.part';
import { DeliveryFollowUpsFollowUpsViewPart } from './scheduled-follow-ups/scheduled-follow-ups.part';
@Component({
	selector: 'delivery-engagements-views-part',
	standalone: true,
	imports: [
		DeliveryFollowUpsFollowUpsViewPart,
		DeliveryContactReqFollowUpsViewPart,
		DeliveryEngagementsOpenEngagementsViewPart,
		DeliveryEngagementsCompletedEngagementsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './engagements-views.part.html',
})
export class DeliveryEngagementsViewsPart implements OnInit {

	public service = inject(DeliveryEngagementsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}